import { Box, Button, Dialog, Fade, Grow, Paper, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const DialogError = (props) => {
    return (
        <Dialog open={props.open} onClose={props.onClose} disableEscapeKeyDown>
            <Paper
                sx={(theme) => ({
                    padding: "3rem 5rem",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: ".75rem",
                    [theme.breakpoints.up("sm")]: {
                        padding: "3.5rem 8rem",
                    },
                })}
            >
                <Box
                    sx={{
                        width: "100px",
                        height: "100px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#dc3545",
                        borderRadius: "50%",
                        marginBottom: "1rem",
                    }}
                >
                    <Grow in={true} easing="ease-in-out" timeout={500}>
                        <CloseRoundedIcon sx={{ fontSize: "5rem", color: "white" }} />
                    </Grow>
                </Box>
                <Fade in={true} easing="ease-in-out" timeout={400}>
                    <Typography
                        sx={(theme) => ({
                            fontSize: "1.5rem",
                            fontWeight: 500,
                            textAlign: "center",
                            color: "#333",
                            lineHeight: "1.8rem",
                            [theme.breakpoints.up("sm")]: {
                                fontSize: "2rem",
                            },
                        })}
                    >
                        ส่งเมลไม่สำเร็จ
                    </Typography>
                </Fade>
                <Fade in={true} easing="ease-in-out" timeout={400}>
                    <Typography sx={{ fontSize: "1rem", fontWeight: 400, textAlign: "center", color: "#999" }}>
                        โปรดลองใหม่อีกครั้ง
                    </Typography>
                </Fade>
                <Fade in={true} easing="ease-in-out" timeout={400}>
                    <Button
                        variant="contained"
                        onClick={props.onClose}
                        sx={{
                            fontSize: "1rem",
                            color: "white",
                            backgroundColor: "#dc3545",
                            padding: ".5rem 3rem",
                            marginTop: "1rem",
                            "&:hover": {
                                color: "white",
                                backgroundColor: "#dc3545",
                                opacity: "0.85",
                            },
                        }}
                    >
                        ปิด
                    </Button>
                </Fade>
            </Paper>
        </Dialog>
    );
};

export default DialogError;
